import React from "react"
import styled from "styled-components"

export const FlexRow = styled.div`
    display: flex;
    justify-content: start;
    flex-direction: row;
    align-items: center;
`

export const FlexRowCenter = styled(FlexRow)`
    justify-content: center;
`

export const FlexColumnMargin10 = ({style, className, children}) => {
    return <div className={`flex-column margin10 ${className ? className : ''}`} style={style}>{children}</div>
}